import React, { lazy } from 'react';
import { useCurrency } from './CurrencyContext';
import { useCart } from './CartContext';
export function ValueStackSection() {
  const {
    formatPrice,
    loading
  } = useCurrency();
  const {
    openCart
  } = useCart();
  return <section className="py-16 md:py-20 px-4 bg-[#FFFBF0] pt-[23px] pb-[23px]" data-id="element-229">
      <div className="max-w-2xl mx-auto flex flex-col items-center" data-id="element-230">
        {/* Headline */}
        <h2 className="md:text-3xl font-black text-center mb-8 text-gray-900 font-[Merriweather,_serif] text-[24px]" data-id="element-231">
          Oferta Recién Horneada 🍞{' '}
          <span className="text-[#D9A441]" data-id="element-232">pagas 1, llevas 10 GRATIS</span>
        </h2>

        {/* Bonus Image */}
        <div className="w-full mb-10" data-id="element-233">
          <img src="https://cdn.magicpatterns.com/uploads/icSYvH3V3aiFfurwG7Kwqi/ChatGPT_Image_6_abr_2026,_11_04_37_p.m..png" alt="10 bonos premium incluidos - Recetas sin gluten, sin lactosa, sin harinas y más" className="w-full max-w-xl mx-auto rounded-2xl shadow-[0_8px_40px_rgba(0,0,0,0.10)]" loading="lazy" data-id="element-234" />
        </div>

        {/* Green Bonus Card */}
        <div className="relative w-full max-w-md mx-auto mt-2 mb-8" data-id="element-235">
          <div className="absolute -top-3 left-1/2 -translate-x-1/2 z-10" data-id="element-236">
            <span className="bg-[#22C55E] text-white text-[11px] font-bold px-3.5 py-1 rounded-full shadow-sm whitespace-nowrap tracking-wide flex items-center gap-1.5" data-id="element-237">
              🎁 ACCESO ESPECIAL
            </span>
          </div>
          <div className="bg-[#F0FDF4] border border-[#4ADE80]/60 rounded-xl p-5 pt-7 shadow-[0_4px_16px_rgba(34,197,94,0.08)]" data-id="element-238">
            <div className="flex justify-center mb-3" data-id="element-239">
              <div className="w-9 h-9 bg-white rounded-full flex items-center justify-center shadow-sm border border-green-100" data-id="element-240">
                <svg className="w-4 h-4 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-241">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" data-id="element-242" />
                </svg>
              </div>
            </div>
            <h3 className="text-[#16A34A] text-base md:text-lg font-bold text-center mb-3 tracking-tight" data-id="element-243">
              CONTENIDO NUEVO CADA SEMANA
            </h3>
            <div className="text-gray-600 text-center space-y-2.5 text-sm leading-relaxed" data-id="element-244">
              <p data-id="element-245">
                Accede a contenido exclusivo que se actualiza constantemente con
                nuevas recetas, mejoras y técnicas.
              </p>
              <p data-id="element-246">
                Siempre tendrás nuevas ideas y nuevas formas de mejorar tus
                resultados sin estancarte.
              </p>
            </div>
          </div>
        </div>

        {/* Dark Premium Price Card */}
        <div className="w-full max-w-md mx-auto bg-gradient-to-b from-[#2A2A1E] to-[#1A1A12] rounded-xl p-6 md:p-7 shadow-[0_6px_24px_rgba(0,0,0,0.18)] border border-[#3A3A2E]" data-id="element-247">
          <div className="text-center space-y-2 mb-6" data-id="element-248">
            <p className="text-gray-300 text-xs md:text-sm tracking-wide font-medium" data-id="element-249">
              Valor real de todo el sistema:{' '}
              <span className="text-[#D9A441] line-through decoration-red-500 decoration-2 ml-1" data-id="element-250">
                {loading ? '...' : formatPrice(137)}
              </span>
            </p>
            <p className="text-[#E8D0B6] text-xs md:text-sm font-bold tracking-widest uppercase mt-3 mb-1" data-id="element-251">
              Hoy todo incluido por solo
            </p>
            <p className="text-4xl md:text-5xl font-black text-[#D9A441] tracking-tight leading-none drop-shadow-[0_2px_8px_rgba(217,164,65,0.25)]" data-id="element-252">
              {'$12.95'}
            </p>
          </div>

          <div className="flex flex-col items-center" data-id="element-253">
            <p className="text-[#FCD34D] text-[10px] md:text-xs font-bold mb-3 animate-pulse" data-id="element-254">
              ⚠️ Esta oferta desaparece al cerrar esta página
            </p>

            <button onClick={openCart} className="w-full bg-gradient-to-b from-[#FCD34D] to-[#D9A441] hover:from-[#FDE68A] hover:to-[#EAB308] text-[#1A1A12] font-black py-3.5 px-5 rounded-lg shadow-[0_3px_14px_rgba(217,164,65,0.35)] hover:shadow-[0_4px_18px_rgba(217,164,65,0.45)] transition-all duration-200 text-center hover:-translate-y-0.5 cursor-pointer text-[20px]" data-id="element-255">
              Quiero mi acceso ahora!
            </button>

            <div className="mt-4 flex flex-wrap justify-center gap-x-3 gap-y-1.5 text-[#A1A1AA] text-[10px] md:text-[11px] font-medium" data-id="element-256">
              <span className="flex items-center gap-1" data-id="element-257">
                <svg className="w-3.5 h-3.5 text-[#D9A441]" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-258">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" data-id="element-259" />
                </svg>
                Acceso inmediato
              </span>
              <span className="flex items-center gap-1" data-id="element-260">
                <svg className="w-3.5 h-3.5 text-[#D9A441]" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-261">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" data-id="element-262" />
                </svg>
                Garantía 30 días
              </span>
              <span className="flex items-center gap-1" data-id="element-263">
                <svg className="w-3.5 h-3.5 text-[#D9A441]" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-264">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" data-id="element-265" />
                </svg>
                Pago 100% seguro
              </span>
              <span className="flex items-center gap-1" data-id="element-266">
                <svg className="w-3.5 h-3.5 text-[#D9A441]" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-267">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" data-id="element-268" />
                </svg>
                Sin suscripciones
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}